import { render, staticRenderFns } from "./mianfei_fabu.vue?vue&type=template&id=4aba3cac&scoped=true"
import script from "./mianfei_fabu.vue?vue&type=script&lang=js"
export * from "./mianfei_fabu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aba3cac",
  null
  
)

export default component.exports